import { createContext, useReducer } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const reducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_USER": {
      return { ...state, user: action.payload };
    }
    default: {
      return state;
    }
  }
};

const UserContext = createContext({
  user: [],
  updateUser: () => {},
});
export const UserDetailsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, []);

  const updateUser = async (id, PassOld, PassNew) => {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/userProfile/${id}`,
        {
          PassOld,
          PassNew,
        }
      );
      dispatch({ type: "UPDATE_USER", payload: res.data });
    } catch (error) {
      Swal.fire({
        title: "old password is invalid or password does not match",
        icon: "error",
        timer: 2000,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  };

  return (
    <UserContext.Provider
      value={{
        user: state.user,
        updateUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
